<template>
  <div class="item-box" v-if="!hide" v-bind:class="selected ? 'item-selected' : ''" @click="toggle">
    <slot name="content">
      <span class="item-name"><van-icon v-if="icon" :name="icon" /> {{name}}</span>
      <img v-if="selected" src="../assets/images/item-selected.png" alt="">
      <img v-if="rec" style="left: -0.5px; width: 29px; top: 0px;" src="../assets/images/rec.png" alt="">
      <div>
        <van-tag class="info-tips" v-if="tips" type="danger">{{tips}}</van-tag>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: "sby-block-select",
  props: {
    name: String,
    value: String,
    icon: {
      type: String
    },
    checked: {
      type: Boolean,
      default: false
    },
    rec: {
      type: Boolean,
      default: false
    },
    tips: {
      type:String,
      default: '',
    },
    change: Function,
    // 是否可以修改
    canModify: {
      type: Boolean,
      default: true
    },
    hide: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  data() {
    return {
      selected: this.checked
    };
  },
  watch: {
    checked(value) {
      this.selected = value;
    }
  },
  mounted() {},
  methods: {
    toggle() {
      if (this.canModify) {
        this.$emit("change", !this.selected, this.value);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/var.less";
.info-tips {
  position: absolute;
  top: -12px;
  right: -12px;
  padding: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/sby-block-select.vue